export default "__VITE_ASSET__2VXC52yS__"